import getColor from "@insite/mobius/utilities/getColor";
import Styleguide from "@store/Framework/Types/Styleguide";
import ChevronLeft from "@store/Library/Components/Icons/ChevronLeft";
import ChevronRight from "@store/Library/Components/Icons/ChevronRight";
import { menuPanelRowResetStyles, menuPanelRowStyles } from "@store/Themes/common/mixins/menu";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { menuPanelProps } from "@store/Themes/common/props/menu";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { IconWrapper } from "@insite/mobius/Icon";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import ArrowBackward from "@store/Library/Components/Icons/ArrowBackward";
/* Store Custom Code - End */

const panelMenu: Styleguide["panelMenu"] = {
    defaultProps: {
        cssOverrides: {
            children: menuPanelProps.wrapperCss,
            menu: css`
                flex: 1 1 auto;
            `,
        },
        closeButtonPanelRowProps: {
            css: menuPanelProps.headerCss,
        },
        closeButtonProps: menuPanelProps.closeButton,
        closeIconProps: menuPanelProps.closeButtonIcon,
        parentPanelRowProps: {
            css: menuPanelRowResetStyles(),
        },
        parentButtonProps: {
            ...buttonResetProps,
            css: css`
                ${buttonResetProps.css}
                ${menuPanelRowStyles()}
                display: flex;
                align-items: center;
                width: 100%;
                text-align: left;
                font-weight: ${x => x.theme.design.typography.weight.bold}; /* Store Custom Code */

                /* Store Custom Code - Force width because backIconProps is ignored */
                > ${IconWrapper} {
                    svg {
                        width: ${pxToRem(40)};
                    }
                }
            `,
        },
        parentLinkProps: {
            css: css`
                ${menuPanelRowStyles({
                    iconPosition: "right",
                    color: "secondary.dark", // Store Custom Code
                })}

                flex: 0 0 0%;
                white-space: nowrap;
                padding-left: 0;
                font-weight: ${x => x.theme.design.typography.weight.base}; /* Store Custom Code */
                text-decoration: underline; /* Store Custom Code */
            `,
        },
        backIconProps: { src: ArrowBackward, width: 40 }, // Store Custom Code
        parentTypographyProps: {
            ellipsis: true,
            weight: "bold", // Store Custom Code
        },
        bodyColor: "transparent",
        panelRowProps: {
            css: css`
                ${menuPanelRowStyles({ iconPosition: "right" })}

                /* Store Custom Code */
                ${({ theme }) => css`
                    font-size: ${theme.design.typography.size.base};
                `}
            `,
            isCurrentCss: css`
                /* Store Custom Code */
                background-color: transparent;
                color: ${getColor("text.main")};
                font-weight: ${x => x.theme.design.typography.weight.bold};
                span {
                    font-weight: ${x => x.theme.design.typography.weight.bold};
                }
            `,
            moreIconProps: { src: ChevronRight },
        },
        childTypographyProps: {
            size: "inherit",
            weight: "normal", // Store Custom Code
        },
    },
};

export default panelMenu;
